//@ts-nocheck
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import iconHeartSelected from "assets/icons/heart-selected.svg";
import iconStartUnselected from "assets/icons/heart-unselected.svg";
import _ from "lodash";
import moment from "moment-timezone";
import styled from "styled-components";

import { NotFoundWrapper } from "components/pages/dormitories-page";
import PaginationControl from "components/tools/pagination-control";
import { Control } from "components/ui-kit/control";
import {
    Breadcrumb,
    Button,
    Container,
    Form,
    Frame,
    Row,
    RowWrapper,
    TExtra
} from "components/ui-kit/styled-templates";

import { EVENT_TYPES_OPTIONS } from "constants/config";

import EventsApi from "api/events-api";
import ReviewsApi from "api/reviews-api";
import UniversityApi from "api/university-api";
import UserApi from "api/user-api";

import useBodyBackground from "hooks/useBodyBackground";
import useFormControl from "hooks/useFormControl";
import usePagination from "hooks/usePagination";
import { useStorageListener } from "hooks/useStorage";

import { EForms } from "types/enums";
import Select from "react-select";
import ClubsApi from "../../api/clubs-api";
import HoverDatePicker from "components/tools/hover-date-picker";

const dormitoriesStub = new Array(54).fill({});

const interferance = (path: string, value: any) => (i: any) => _.get(i, path)?.includes?.(value ?? ``);
const arrayToOptions = (i: any) => ({ value: i, label: i });

function getSortedEvents(arr) {
    return arr.sort((a, b) => {
        let t1 = +a?.details?.dates?.from;
        let t2 = +b?.details?.dates?.from;
        let p1 = +a?.details?.price;
        let p2 = +b?.details?.price;
        let w = 1000000000;
        return +t1 + w * p1 - (+t2 + w * p2);
    });
}

const EventsSearchPage = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    useBodyBackground(`white`);
    let isRu = i18n.language === `ru`;

    const universities = useStorageListener(`universities`, {});
    const clubs = useStorageListener(`clubs`, {});

    console.log("clubs = ", clubs);

    const reviews = useStorageListener(`reviews`, []);
    // const rooms = useStorageListener(`rooms`, {});

    const events = useStorageListener(`events`, {});

    const { data, clearForm, setValues } = useFormControl({ name: EForms.searchFilters });

    // Валидация диапазона дат: дата начала не может быть позже даты окончания
    useEffect(() => {
        if (data.dateFrom && data.dateTo) {
            const fromTimestamp = +data.dateFrom;
            const toTimestamp = +data.dateTo;
            if (fromTimestamp > toTimestamp) {
                // Если дата начала позже даты окончания - меняем местами
                setValues({ ...data, dateFrom: data.dateTo, dateTo: data.dateFrom });
            }
        }
    }, [data.dateFrom, data.dateTo]);

    // const selectedRooms = _(rooms).values().filter(interferance("details.type", data.type)).map(`dormitoryId`).uniq().value();

    const getEventRating = (eventId) => {
        const eventReviews = _(reviews)
            .filter((i) => i.published)
            .filter({ eventId })
            .value();
        const eventRating = _(eventReviews).map(`rating`).sum() / (eventReviews.length || 1);
        return eventRating;
    };



    const filteredEvents = _(events)
        .values()
        .map((event) => ({
            ...event,
            university: universities[event.universityId],
            rating: getEventRating(event.id),
            country: (_.get(universities, `${event.universityId}.details.country`)) || "РОССИЯ"
        }))
        .filter(interferance("details.type", data.type))
        .filter(interferance("university.details.city", data.city))
        .filter(interferance("country", data.country))
        .filter(interferance("university.details.region", data.region))
        .filter(interferance("universityId", data.university))
        .filter((x) => x?.onModeration !== true && x?.hideFromAll !== true)

        // .filter(interferance("details.clubId", data.clubId))
        // .filter(interferance("details.main-info.mealPlan", data.mealPlan))

        // // .filter((i) => i?.details?.documents?.length > 0)
        // .filter((i) => selectedRooms.includes(i.id))
        // .filter((i) => {
        //     // Filter by rules completness
        //     // TODO: Redo this using yup schema
        //     const requiredFields = [`requiredUniDocuments`, `requiredStudentsDocuments`, `committee.email`, `committee.phone`, `committee.name`];
        //     return requiredFields.map((path) => _.get(i, `details.rules.${path}`)).filter((i) => !i).length === 0;
        // })
        // .sortBy([`details.main-info.name`])
        // .sortBy([`details.dates.from`])
        .sortBy(["details.dates.from"])
        .orderBy("rating", data.ratingDirection || "desc")
        .value();

    // console.log(_.uniq(filteredEvents.map((i) => i.rating)));

    console.log("filteredEvents = ", filteredEvents);
    // console.log('22 filteredEvents = ', filteredEvents.filter(x => (x.clubId != undefined && x.clubId != '')));

    let now = +new Date();
    let futureEvents = filteredEvents.filter((x) => +x?.details?.dates?.to > +now);

    console.log('Date filter debug: data.dateFrom =', data.dateFrom, 'data.dateTo =', data.dateTo, 'type:', typeof data.dateFrom, typeof data.dateTo);

    // Фильтрация по выбранным датам (data.dateFrom и data.dateTo приходят как timestamp от DatePicker)
    if (data.dateFrom && !isNaN(+data.dateFrom)) {
        const dateFromTimestamp = +moment(+data.dateFrom).startOf('day');
        console.log('Filtering by dateFrom:', dateFromTimestamp, 'original:', data.dateFrom);
        futureEvents = futureEvents.filter((x) => +x?.details?.dates?.to >= dateFromTimestamp);
    }
    if (data.dateTo && !isNaN(+data.dateTo)) {
        const dateToTimestamp = +moment(+data.dateTo).endOf('day');
        console.log('Filtering by dateTo:', dateToTimestamp, 'original:', data.dateTo);
        futureEvents = futureEvents.filter((x) => +x?.details?.dates?.from <= dateToTimestamp);
    }

    console.log('After date filter: futureEvents count =', futureEvents.length);

    let goodUniIds = [];
    for (let i in futureEvents) {
        let event = futureEvents[i];
        if (event?.universityId != undefined && event?.universityId != "" && !goodUniIds.includes(event?.universityId)) {
            goodUniIds.push(event?.universityId);
        }
    }

    // let oldEvents = filteredEvents.filter(x => (+x?.details?.dates?.to < +now));
    let oldEvents = [];
    let visEvents = getSortedEvents(futureEvents).concat(getSortedEvents(oldEvents));

    if (data.clubId != undefined) {
        visEvents = visEvents.filter(x => (x?.details?.clubId == data.clubId));
    }
    let goodUnis = Object.values(universities).filter(xx => (goodUniIds.indexOf(xx.id) > -1));
    console.log('goodUnis = ', goodUnis);

    const filterOptions = {
        city: _(visEvents as any)
            .values()
            .map(`university.details.city`)
            .uniq()
            .map(arrayToOptions)
            .sortBy([`label`])
            .value(),
        country: _(visEvents as any)
            .values()
            .map(`university.details.country`)
            .filter(x => (x != "" && x != undefined))
            .concat("РОССИЯ")
            .uniq()
            .map(arrayToOptions)
            .sortBy([`label`])
            .value(),
        university: _(universities).values()
            .uniqBy(`id`)
            .map((i) => ({ label: _.get(i, `details.shortName`, _.get(i, `details.name`, "")), value: i.id }))
            .value(),
        type: EVENT_TYPES_OPTIONS,
        region: _(visEvents as any)
            .values()
            .map(`university.details.region`)
            .uniq()
            .map(arrayToOptions)
            .sortBy([`label`])
            .value(),
        ratingDirection: ["asc", "desc"].map((i) => ({
            value: i,
            label: t(`searchResultsPage.ratingDirection.${i}`)
        }))
    };

    const paginationResult = usePagination(visEvents as any, { perPage: 4 });
    const { visibleItems } = paginationResult;

    useEffect(() => {
        UniversityApi.getAllUniversitiesData();
        ReviewsApi.getAllReviews();
        ClubsApi.getAllClubs();
    }, []);

    useEffect(() => {
        EventsApi.getEvents();
    }, []);

    let filteredRegions = (filterOptions?.region || []).sort((a, b) => {
        let s1 = a.value;
        let s2 = b.value;
        if (s1.indexOf("ЕА") > -1) {
            s1 = `_${s1}`;
        }
        if (s2.indexOf("ЕА") > -1) {
            s2 = `_${s2}`;
        }
        if (s1 > s2) {
            return 1;
        }
        if (s1 < s2) {
            return -1;
        }
        return 0;
    }).sort((a, b) => {
        if (a.label > b.label) {
            return 1;
        }
        if (a.label < b.label) {
            return -1;
        }
        return 0;
    });


    let clubsOptions = [];
    try {
        clubsOptions = Object.values(clubs).filter(x => (x.onModeration != true)).map((i) => ({
            value: i?.id,
            label: i?.details?.name
        }));
    } catch (exc) {

    }

    let filterUnis = filterOptions.university;
    console.log('filterUnis = ', filterUnis);
    filterUnis = filterUnis.filter(x => (goodUniIds.indexOf(x.value) > -1));

    return (
        <Container extra={`align-items: flex-start;`}>
            <Breadcrumb.Wrapper>
                <Breadcrumb.Item to="/">{t("t5e9y72hvoo")}</Breadcrumb.Item>
                <Breadcrumb.Item to="/search">{t("zvbcemu3r8e")}</Breadcrumb.Item>
            </Breadcrumb.Wrapper>
            <RowWrapper
                extra={`h1 { margin: 0; display: flex; flex-direction: row; justify-content: space-between; };`}>
                <h1>{t("4ys0jfw3eka")}</h1>
                <Button

                    onClick={() => {
                        navigate("/international");
                    }}>
                    {isRu ? "Международные программы" : "International programs"}
                </Button>
            </RowWrapper>
            <RowWrapper extra={`margin-top: 56px; flex-wrap: wrap; gap: 32px; align-items: flex-start;`}>
                <FiltersWrapper name={EForms.searchFilters}>
                    <h2>{t("tvryp728hb")}</h2>

                    {/*<Control.Select*/}
                    {/*    name="country"*/}
                    {/*    placeholder={isRu ? "Страна" : "Country"}*/}
                    {/*    label={isRu ? "Страна" : "Country"}*/}
                    {/*    options={filterOptions.country}*/}
                    {/*    menuProps={{ extra: `> * { max-width: 250px; }` }}*/}
                    {/*/>*/}

                    <div className={"mb-8"}>
                        <div>
                            <Label>{isRu ? "Страна" : "Country"}</Label>
                        </div>
                        <Select
                            name="country"
                            placeholder={isRu ? "Страна" : "Country"}
                            options={filterOptions.country}
                            isClearable={true}
                            onChange={x => {
                                let val = x?.value;
                                setValues({ ...data, country: val });
                            }}
                        />
                    </div>

                    {/*<Control.Select*/}
                    {/*    name="type"*/}
                    {/*    placeholder={t("t3jsvmx68q8")}*/}
                    {/*    label={t("looz9gqehzc")}*/}
                    {/*    options={filterOptions.type}*/}
                    {/*    menuProps={{ extra: `> * { max-width: 250px; }` }}*/}
                    {/*/>*/}

                    <div className={"mb-8"}>
                        <div>
                            <Label>{t("looz9gqehzc")}</Label>
                        </div>
                        <Select
                            name="type"
                            placeholder={t("t3jsvmx68q8")}
                            options={filterOptions.type}
                            isClearable={true}
                            onChange={x => {
                                let val = x?.value;
                                setValues({ ...data, type: val });
                            }}
                        />
                    </div>

                    {/*<Control.Select*/}
                    {/*    name="university"*/}
                    {/*    placeholder={t("slguq6rk4ms")}*/}
                    {/*    label={t("vqy9f871xai")}*/}
                    {/*    options={filterOptions.university}*/}
                    {/*    menuProps={{ extra: `> * { max-width: 250px; }` }}*/}
                    {/*/>*/}

                    <div className={"mb-8"}>
                        <div>
                            <Label>{t("vqy9f871xai")}</Label>
                        </div>
                        <Select
                            name="university"
                            placeholder={t("slguq6rk4ms")}
                            options={filterUnis}
                            isClearable={true}
                            onChange={x => {
                                let val = x?.value;
                                setValues({ ...data, university: val });
                            }}
                        />
                    </div>

                    <div className={"mb-8"}>
                        <div>
                            <Label>{isRu ? "Студтурклуб" : "Tour club"}</Label>
                        </div>
                        <Select
                            name="type"
                            placeholder={isRu ? "Студтурклуб" : "Tour club"}
                            options={clubsOptions}
                            isClearable={true}
                            onChange={x => {
                                let val = x?.value;
                                setValues({ ...data, clubId: val });
                            }}
                        />
                    </div>


                    {/*<Control.Select name="region" placeholder={t("sd1hnuvfi3f")} label={t("91parqfw3d")}*/}
                    {/*                options={filteredRegions} />*/}

                    <div className={"mb-8"}>
                        <div>
                            <Label>{t("91parqfw3d")}</Label>
                        </div>
                        <Select
                            name="region"
                            placeholder={t("sd1hnuvfi3f")}
                            options={filteredRegions}
                            isClearable={true}
                            onChange={x => {
                                let val = x?.value;
                                setValues({ ...data, region: val });
                            }}
                        />
                    </div>

                    {/*<Control.Select*/}
                    {/*    name="city"*/}
                    {/*    placeholder={t("ssd650u8gt")}*/}
                    {/*    label={t("q3hf416oqjj")}*/}
                    {/*    options={filterOptions.city}*/}
                    {/*    menuProps={{ extra: `> * { max-width: 250px; }` }}*/}
                    {/*/>*/}

                    <div className={"mb-8"}>
                        <div>
                            <Label>{t("q3hf416oqjj")}</Label>
                        </div>
                        <Select
                            name="city"
                            placeholder={t("ssd650u8gt")}
                            options={filterOptions.city.sort((a, b) => {
                                if (a.label > b.label) {
                                    return 1;
                                }
                                if (a.label < b.label) {
                                    return -1;
                                }
                                return 0;
                            })}
                            isClearable={true}
                            onChange={x => {
                                let val = x?.value;
                                setValues({ ...data, city: val });
                            }}
                        />
                    </div>


                    {/*<Control.Select*/}
                    {/*    name="ratingDirection"*/}
                    {/*    placeholder={t("ufvp0iyg6a")}*/}
                    {/*    label={t("ufvp0iyg6a")}*/}
                    {/*    options={filterOptions.ratingDirection}*/}
                    {/*/>*/}

                    <div className={"mb-8"}>
                        <div>
                            <Label>{t("ufvp0iyg6a")}</Label>
                        </div>
                        <Select
                            name="ratingDirection"
                            placeholder={t("ufvp0iyg6a")}
                            options={filterOptions.ratingDirection}
                            isClearable={true}
                            onChange={x => {
                                let val = x?.value;
                                setValues({ ...data, ratingDirection: val });
                            }}
                        />
                    </div>

                    <div className={"mb-8"}>
                        <DateFilterHeader>
                            <Label style={{ marginBottom: 0 }}>{isRu ? "Даты проведения" : "Event dates"}</Label>
                            {(data.dateFrom || data.dateTo) && (
                                <ClearDatesButton
                                    onClick={() => setValues({ ...data, dateFrom: undefined, dateTo: undefined })}
                                >
                                    {isRu ? "сбросить" : "clear"}
                                </ClearDatesButton>
                            )}
                        </DateFilterHeader>
                        <DateFilterRow>
                            <DateFilterField>
                                <HoverDatePicker
                                    value={data.dateFrom}
                                    placeholder={isRu ? "С" : "From"}
                                    withTime={false}
                                    saveOnSelect={true}
                                    onChange={(e: any) => setValues({ ...data, dateFrom: e.target.value })}
                                />
                            </DateFilterField>
                            <DateFilterField>
                                <HoverDatePicker
                                    value={data.dateTo}
                                    placeholder={isRu ? "По" : "To"}
                                    withTime={false}
                                    saveOnSelect={true}
                                    onChange={(e: any) => setValues({ ...data, dateTo: e.target.value })}
                                />
                            </DateFilterField>
                        </DateFilterRow>
                    </div>

                    <Row extra={`width: 100%; justify-content: center;`}>
                        <Button variant="outlined" extra="border: 0px;" onClick={clearForm}>
                            {t("wy5yz61f2u")}
                        </Button>
                    </Row>
                </FiltersWrapper>
                <Frame extra={`width: 100%; flex: 1; align-items: flex-start; gap: 15px 0; a { width: 100%; };`}>
                    <h2>
                        {t("3v5uoaamac7")} {paginationResult.totalCount}
                    </h2>
                    {visibleItems.map((item: any, index: number) => {
                        const goTo = (e) => {
                            if (e.target.className.includes("link-ignore")) {
                                return;
                            }
                            navigate(`/events/${item.id}`);
                        };
                        return (
                            <div key={index} onClick={goTo}>
                                <EventSearchPreview.Component eventId={item.id} event={item}
                                                              club={_.get(clubs, item?.details?.clubId)}
                                                              university={_.get(universities, item?.universityId)} />
                            </div>
                        );
                    })}
                    {!dormitoriesStub.length && <NotFoundWrapper>{t("hcbz42ae1vn")}</NotFoundWrapper>}
                    <PaginationControl pagination={paginationResult} />
                </Frame>
            </RowWrapper>
        </Container>
    );
};

export const EventSearchPreview = {
    Component: ({ eventId, ...props }: any) => {
        const { t, i18n } = useTranslation();
        let isRu = i18n.language === `ru`;

        const { event, university, club } = props;

        const user = useStorageListener(`user`, {});

        const isStarred = _.get(user, "starredEvents", []).includes(eventId);

        console.log("EventSearchPreview: club = ", club);
        console.log("EventSearchPreview: event = ", event);

        const startEvent = () => {
            UserApi.toggleEventStar(eventId);
        };
        return (
            <EventSearchPreview.Wrapper className="cursor-pointer">
                <div className="flex flex-row w-full justify-between items-center">
                    <h3>{_.get(event, `details.name`)}</h3>
                    <img
                        alt=""
                        src={isStarred ? iconHeartSelected : iconStartUnselected}
                        className="link-ignore w-6 h-6 cursor-pointer"
                        onClick={startEvent}
                    />
                </div>
                <div
                    className="type">{EVENT_TYPES_OPTIONS.find((i) => i.value === _.get(event, `details.type`)).label}</div>
                <div>{t("5c4ea9b1fzy")}</div>
                <strong>{_.get(university, `details.name`)}</strong>
                {(_.get(club, `details.name`) == undefined || _.get(club, `details.name`) == "") ? null :
                    <>
                        <div>{`Студтурклуб`}</div>
                        <strong>{_.get(club, `details.name`)}</strong>
                    </>
                }
                <Row extra="width: 100%; > * { flex: 1; };">
                    <div>
                        <div>{t("0xyh3sxxgnyl")}</div>
                        <strong>{_.get(event, `details.price`)} ₽</strong>
                    </div>
                    <div>
                        <div>{t("uu7g0iwo5cj")}</div>
                        <strong>
                            {moment(event?.details?.dates?.from).format(`DD.MM.YYYY`)} - {moment(event?.details?.dates?.to).format(`DD.MM.YYYY`)}
                        </strong>
                    </div>
                    {event?.details?.from_time == undefined || event?.details?.from_time == "" ? null :
                        <div>
                            <div>{isRu ? "Время начала" : "Start time"}</div>
                            <strong>
                                {event?.details?.from_time}
                            </strong>
                        </div>
                    }
                </Row>
                <div>
                    {_.get(event, `details.description`).slice(0, 100)}
                    {_.get(event, `details.description`).length > 100 ? `...` : ``}
                </div>
                <div className="details">{t("f9hqqxcdpyr")}</div>
            </EventSearchPreview.Wrapper>
        );
    },
    Wrapper: styled(Frame)`
      border: 1px solid ${({ theme }) => theme.halfblue};
      box-sizing: border-box;
      border-radius: 8px;
      overflow: hidden;
      align-items: flex-start;
      padding: 24px 20px;
      box-sizing: border-box;
      /* width: 100%; */
      gap: 15px;

      font-size: 15px;
      line-height: 20px;

      .type {
        color: ${({ theme }) => theme.blue};
        font-weight: 400;
        font-size: 13px;
      }

      .details {
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        color: ${({ theme }) => theme.blue};
      }

      h3 {
        margin: 0 0 8px 0;
      }

      .uni-name {
        font-family: "Noto Sans", sans-serif;
        font-weight: 600;
        font-size: 18px;
        line-height: 27px;
        color: ${({ theme }) => theme.grey};
      }

      .region {
        font-weight: 400;
        font-size: 13px;
        line-height: 17px;
        color: ${({ theme }) => theme.blue};
      }
    `,
    Photo: styled(Frame)<{ src?: string; extra?: TExtra }>`
      width: 256px;
      height: 322px;
      background: ${({ theme }) => theme.lightblue};
      ${({ src }) => src && `background: url('${src}') no-repeat center center / cover;`}

      ${({ extra }) => extra}
    `,
    TableWrapper: styled(Row)`
      flex-wrap: wrap;
      gap: 16px 8px;
      margin-top: 16px;

      > * {
        align-items: flex-start;
        width: calc(50% - 8px);
        gap: 8px;
        font-size: 15px;
        line-height: 20px;
      }
    `,
    ContentWrapper: styled(Frame)`
      width: 100%;
      align-items: flex-start;
      justify-content: space-between;
      padding: 24px;
      box-sizing: border-box;
      height: 322px;
    `
};


const Label = styled.div`
  color: rgb(33, 33, 33);
  margin-bottom: 8px;
  font-size: 14px;
`;

const FiltersWrapper = styled(Form)`
  width: 373px;
  background: ${({ theme }) => theme.lightblue};
  border-radius: 12px;
  padding: 40px 32px;
  box-sizing: border-box;

  h2 {
    margin: 0 0 15px 0;
  }

  span {
    background: white;
  }
`;

const DateFilterRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const DateFilterField = styled.div`
  flex: 1;

  input {
    background: white;
    border-radius: 4px;
  }
`;

const DateFilterHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const ClearDatesButton = styled.span`
  color: #2196F3;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    opacity: 0.8;
  }
`;

export default EventsSearchPage;
